import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { PDSService } from '../../../services/pds.service';
@Component({
  selector: 'app-travel-medical-insurance',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './travel-medical-insurance.component.html',
  styleUrl: './travel-medical-insurance.component.scss',
})
export class TravelMedicalInsuranceComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle(
      'Travel Medical Insurance | World2Cover Australia',
    );
    this.metaService.updateTag({
      name: 'description',
      content:
        'World2Cover international travel insurance covers overseas emergencies, hospital care and dental, and you can get a free quote online.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Travel Medical Insurance | World2Cover Australia',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover international travel insurance covers overseas emergencies, hospital care and dental, and you can get a free quote online.',
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
